import { lazy, Suspense } from "react";
import { Redirect, Route, Switch } from "wouter";
import { Shell } from "./components/Shell";
import { LoadingPanel } from "./components/Ui";

const Overview = lazy(() => import("./pages/Overview"));
const Rankings = lazy(() => import("./pages/Rankings"));
const Traffic = lazy(() => import("./pages/Traffic"));
const Matrix = lazy(() => import("./pages/Matrix"));
const Movers = lazy(() => import("./pages/Movers"));
const SyncStatus = lazy(() => import("./pages/SyncStatus"));

export default function App() {
  return (
    <Shell>
      <Suspense fallback={<LoadingPanel />}>
        <Switch>
          <Route path="/" component={Overview} />
          <Route path="/rankings" component={Rankings} />
          <Route path="/traffic" component={Traffic} />
          <Route path="/ranking-traffic" component={Matrix} />
          <Route path="/movers" component={Movers} />
          <Route path="/sync" component={SyncStatus} />
          <Route><Redirect to="/" /></Route>
        </Switch>
      </Suspense>
    </Shell>
  );
}
